import template from './releaseNotes.html';
import ReleaseNotesCtrl from './releaseNotesCtrl';

export default {
  template,
  controller: ReleaseNotesCtrl,
  controllerAs: 'vm',
};
